import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Diensten — Websites, platformen & AI | IT Solutions";
const DESC =
  "Van vaste prijspakketten tot maatwerk enterprise-platformen, AI-accelerated engineering, SLA-onderhoud, migraties en strategisch advies. Eén partner voor je hele digitale stack.";

import { DienstenPage } from "@/pages/diensten";

export const Route = createFileRoute("/diensten")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/diensten", title: TITLE, description: DESC }),
  component: DienstenPage,
});
